
import { InitApp } from '@/helpers/main';
import CustomerLogin from './frontend-vue/login.vue';
import CustomerRegister from './frontend-vue/register.vue';
import CustomerBooking from './frontend-vue/Booking.vue';
import ForgetPassword from './frontend-vue/forget_password.vue';
import otpVerify from './frontend-vue/otp-verify.vue';
import resetPassword from './frontend-vue/resetPassword.vue';
import SuggestedProducts from './shop/SuggestedProducts.vue';
import ContactUs from './frontend-vue/contact_us.vue';
import addToCart from './shop/addToCart.vue';
import bookService from './booking/service-booking.vue';
import dashboard from './frontend-vue/dashboard.vue';
import petList from './frontend-vue/petList.vue';
import rewardList from './frontend-vue/rewardList.vue';
import myBookings from './frontend-vue/myBookings.vue';
import myProfile from './frontend-vue/profile-update.vue';

import VueTelInput from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import myViewMedia from './frontend-vue/myViewMedia.vue';

const app = InitApp();
app.use(VueTelInput);

app.component('customer-login', CustomerLogin);
app.component('customer-register', CustomerRegister);
app.component('customer-booking', CustomerBooking);
app.component('forget-password', ForgetPassword);
app.component('otp-verify', otpVerify);
app.component('reset-password', resetPassword);
app.component('products-in-shop', SuggestedProducts);
app.component('contact_us', ContactUs);
app.component('add-to-cart',addToCart);
app.component('book-service-offcanvas',bookService);
app.component('dashboard',dashboard);
app.component('pet-list',petList);
app.component('my-bookings',myBookings);
app.component('my-view-media',myViewMedia);
app.component('my-profile',myProfile);
app.component('my-reward',rewardList);

app.mount('[data-render="frontend"]');


